<template>
  <v-app>

    <v-main class="py-0">

      <div class="at">

        <!-- 標籤 -->
        <v-chip-group v-model="imgtag" mandatory active-class="primary--text" class="my-3">
          <v-chip v-for="tag in tags" :key="tag" outlined class="text-subtitle-1">
            {{ tag }}
          </v-chip>
        </v-chip-group>

        <!-- 畫廊 -->
        <v-row class="mx-3 mx-lg-16">
          <v-col v-for="img in filter_list" :key="img" class="d-flex child-flex col-6 col-md-4 col-lg-3">
            <v-img :src="img.src" aspect-ratio="1" class="grey lighten-4 rounded-lg" @click="ShowOverlay(img.src)">
            </v-img>

          </v-col>
        </v-row>

      </div>

      <v-overlay opacity="0.6" v-if="ov" @click="ov = !ov">
        <template>
          <div class="d-flex flex-column justify-space-between align-center">
            <v-img :src="show_img" class="grey lighten-4 rounded-lg ovly">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="blue lighten-1"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>
        </template>
      </v-overlay>

    </v-main>
  </v-app>
</template>

<style scoped>
.at {
  width: 100%;
  padding: 12px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 960px) {
  .at {
    max-width: 900px;
  }
}

@media (min-width: 1264px) {
  .at {
    max-width: 1185px;
  }
}

@media (min-width: 1704px) {
  .at {
    max-width: 1685px;
  }
}

.ovly {
  max-width: 300px;
}

@media (min-width: 700px) {
  .ovly {
    max-width: 500px;
  }
}
</style>

<script>
export default {

  data: () => ({
    show_img: null,
    ov: false,
    imgtag:0,
    tags: [
      '全部',
      '人物去背',
      '人物建模',
      '表符',
      '壁紙',
      '縮圖',
    ],
    img_list: [
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/人物去背/1.jpg", tag: "人物去背" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/人物去背/2.jpg", tag: "人物去背" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/人物去背/3.jpg", tag: "人物去背" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/人物去背/4.jpg", tag: "人物去背" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/人物去背/5.jpg", tag: "人物去背" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/人物去背/6.jpg", tag: "人物去背" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/人物建模/1.jpg", tag: "人物建模" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/人物建模/2.jpg", tag: "人物建模" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/人物建模/3.jpg", tag: "人物建模" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/人物建模/4.jpg", tag: "人物建模" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/人物建模/5.jpg", tag: "人物建模" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/表符/1.jpg", tag: "表符" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/表符/2.jpg", tag: "表符" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/表符/3.jpg", tag: "表符" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/壁紙/1.jpg", tag: "壁紙" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/壁紙/2.jpg", tag: "壁紙" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/壁紙/3.jpg", tag: "壁紙" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/壁紙/4.jpg", tag: "壁紙" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/壁紙/5.jpg", tag: "壁紙" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/壁紙/6.jpg", tag: "壁紙" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/縮圖/1.jpg", tag: "縮圖" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/縮圖/2.jpg", tag: "縮圖" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/縮圖/3.jpg", tag: "縮圖" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/small/縮圖/4.jpg", tag: "縮圖" },

    ],
    big_list: [
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/人物去背/1.jpg", tag: "人物去背" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/人物去背/2.jpg", tag: "人物去背" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/人物去背/3.jpg", tag: "人物去背" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/人物去背/4.jpg", tag: "人物去背" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/人物去背/5.jpg", tag: "人物去背" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/人物去背/6.jpg", tag: "人物去背" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/人物建模/1.jpg", tag: "人物建模" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/人物建模/2.jpg", tag: "人物建模" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/人物建模/3.jpg", tag: "人物建模" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/人物建模/4.jpg", tag: "人物建模" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/人物建模/5.jpg", tag: "人物建模" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/表符/1.jpg", tag: "表符" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/表符/2.jpg", tag: "表符" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/表符/3.jpg", tag: "表符" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/壁紙/1.jpg", tag: "壁紙" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/壁紙/2.jpg", tag: "壁紙" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/壁紙/3.jpg", tag: "壁紙" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/壁紙/4.jpg", tag: "壁紙" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/壁紙/5.jpg", tag: "壁紙" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/壁紙/6.jpg", tag: "壁紙" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/縮圖/1.jpg", tag: "縮圖" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/縮圖/2.jpg", tag: "縮圖" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/縮圖/3.jpg", tag: "縮圖" },
      { src: "https://www.dreamcity.studio/art/img/yeiyu/big/縮圖/4.jpg", tag: "縮圖" },

  ],
  }),
  methods: {
    ShowOverlay(img_src) {
      let searched = this.img_list.map(obj => {
        if (Object.keys(obj).some(key => obj[key].indexOf(img_src) != -1))
          return obj;
      });
      this.show_img = this.big_list[this.img_list.indexOf(searched.filter(obj => obj != undefined)[0])].src;
      this.ov = !this.ov;
    },
  },
  computed: {
    filter_list() {
      if (this.imgtag == 0) return this.img_list;
      else return this.img_list.filter(img => img.tag == this.tags[this.imgtag]);
    }
  }

}
</script>
